module.exports = __webpack_public_path__ + "static/media/event-02.e8e13143.jpg";